module.exports = __webpack_public_path__ + "static/media/react-hotel.88917f4e.PNG";